export const CUSTOM_PROPERTIES_PREFIX = 'custom_properties.'
export const CUSTOM_PROPERTIES_POSTFIX_MAP = new Map<string, string>([
    ['property_boolean', ''],
    ['property_file', '.name'],
    ['property_member', '.lastname'],
    ['property_text', ''],
    ['property_catalog', '.items_text'],
    ['property_todo', '.items_text'],
])

export interface PropertyModel {
    created_at: string;
    id: number;
    property_type: string;
    property_type_target?: string;
    title: string;
    updated_at: string;
    is_multiform: boolean;
}

export interface ValuePropertyModel {
    property: PropertyModel;
    default_view: boolean;

    catalog?: CatalogModel;
    created_at?: string;
    updated_at?: string;
    property_values?: any;

    show?: boolean;
}

export interface CatalogModel {
    created_at: string;
    description: string;
    id: number;
    is_open: boolean;
    items: CatalogItemModel[];
    items_count: number;
    title: string;
    updated_at: string;
}

export interface CatalogItemModel {
    catalog_id: number;
    created_at: string;
    id: number;
    items_text: string;
    sort_index: number;
    updated_at: string;
}
